export default __webpack_public_path__ + "media/award.b013776d.svg";